import { render, staticRenderFns } from "./CommonInput.vue?vue&type=template&id=06d973ff&scoped=true"
import script from "./CommonInput.vue?vue&type=script&lang=js"
export * from "./CommonInput.vue?vue&type=script&lang=js"
import style0 from "./CommonInput.vue?vue&type=style&index=0&id=06d973ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d973ff",
  null
  
)

export default component.exports